import React, { Component } from 'react';
import './../css/master.css';
import './../css/city.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var httpURL = '';
var queryString = require('querystring');
var lstCity =[];
var cityIdCol 	= 'td:eq(0)';
var cityCol 	= 'td:eq(1)';

class City extends Component {
  constructor(props){
	super(props);
	this.state={
		city:[],
		flg:true,
		loader:'none',
		opacity:1,
	}
  }
  
  componentDidMount =()=> {
	this.setState({loader:'block', opacity:0.5});  
	  axiosInstance.get(httpURL+'/a/mst/cty/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					city:response.data.lstCity,
				})
				lstCity = this.state.city;
				this.setCityTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  }); 
  }
  
  setCityTable =()=> {
		$('#cityTableBody tr').remove();
		var table 				= document.getElementById('cityTable');
		var tbody 				= document.getElementById('cityTableBody');
		var filterCity 		= $('#city').val().toLowerCase();
		
		for(var i=0; i<lstCity.length; i++){
		var id 			= lstCity[i].cityId;
		var city		= lstCity[i].city;
		
		var row = document.createElement('tr');
			row.id = id;
		row.onclick =(e)=>{
			$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			this.setCityForm($(e.target).closest('tr').attr('id'));
			this.setState({flg:false})
		}
		
		if(city.toLowerCase().indexOf(filterCity) === -1)
			continue;
		
		this.addTD(row, id, 'no-display');
		this.addTD(row, city, '');
		
		tbody.append(row);
		}
	table.append(tbody);
	}
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	setCityForm =(id)=> {
		var cityData = this.getCityData(id);
		if(cityData !== -1){
			$('#inp_city').val(cityData.city);
		}
	}
	
	getCityData(id){
		for(var i = 0; i < lstCity.length; i++){
			if(id == lstCity[i].cityId){
				return lstCity[i];
			}
		}
		return -1;
	}
	
	addCityReady =()=>{
		$('#cityAddForm').trigger('reset');
		this.setState({flg:true})
	}
	
	maintainCity =()=>{
		if(this.state.flg){
			this.addCity();
		}else{
			this.editCity();
		}
	}
	
	addCity=()=>{
	var cityArr 		= {};
	var city			= $('#inp_city').val().toUpperCase();
	if(city == ''){
		toast.warning('Please fill city');
		document.getElementById('inp_city').focus();
		return false;
	}
	
	cityArr={'cityId': 0, 'city':city}
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/a/mst/cty/save', 
		queryString.stringify({'city':JSON.stringify(cityArr)}), {withCredentials:true}
	).then((response)=>{	
		if(response.data.SvcStatus === "Success"){
			toast.success(response.data.SvcMsg);
			cityArr.cityId = response.data.cityId;
			lstCity.push(cityArr);
			this.setCityTable();
			this.setCityForm(response.data.cityId);
			this.highlightRow('cityTableBody', response.data.cityId);
			this.setState({flg : false})
		}
		else{
			toast.error(response.data.SvcMsg);
		}
		this.setState({loader:'none', opacity:1});
 	}).catch((e)=>{
         toast.error("Service failed "+e);
  	});
  }

	editCity=()=>{
		var cityArr 		= {};
		var cityId 		= $('#cityTableBody tr.selected').find(cityIdCol).text();
		var city			= $('#inp_city').val().toUpperCase();
		
		if(cityId == ''){
			toast.warning('Please select row');
			return false;
		}
		
		if(city == ''){
			toast.warning('Please fill city');
			document.getElementById('inp_city').focus();
			return false;
		}
		
		cityArr={'cityId': cityId, 'city':city}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/cty/save', 
			queryString.stringify({'city':JSON.stringify(cityArr)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				var cityIdx = this.getIdxCity(cityId);
				lstCity.splice(cityIdx,1,cityArr);
				this.setCityForm(cityId);
				this.setCityTable();
				this.highlightRow('cityTableBody', cityId);
			}
			else{
		        toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	getIdxCity(cityId){
		for(var i=0; i<lstCity.length; i++){
			if(lstCity[i].cityId == cityId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var cityId = $(this).find(cityIdCol).text();
			if(cityId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	
  render() {
	httpURL = window.httpURL;
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-7 col-centered">
						<div className="col-sm-5 col-xs-11 padding-remove">
							<table className="tableLayout">
								<thead>
									<tr>
										<th style={{width:50, display:'none'}}>City Id</th>
										<th style={{width:100}}>
											<input onChange={this.setCityTable} type="text" className="form-control inp-search" id="city" placeholder="City" />
										</th>
									</tr>
								</thead>
							</table>
							<div className="cityTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="cityTable" className="tableLayout">
									<colgroup>
										<col width="100" />
									</colgroup>
									<tbody id="cityTableBody"></tbody>
								</table>
							</div>
						</div>
						<div className="col-sm-1 col-xs-1">
							<span id="addCity" title="Add City" onClick={this.addCityReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-6 col-xs-12">
							<form id="cityAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">City:</label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="City" id="inp_city"/>
									</div>
								</div>
								<div className="form-group" style={{marginTop:50}}>
									<div className="col-sm-12 text-center">
										<button type="button" onClick={this.maintainCity} className="btn btn-warning">Save</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default City;
